import DeleteConfirmation from "components/ui/DeleteConfirmation";
import { useDeleteAgitem } from "http-hooks/agitem/useAgitem";
import { useNavigate } from "react-router-dom";

export default function DeleteItem({ id, onClose }) {
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useDeleteAgitem();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
      navigate("/item-master-bulk");
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Item"
      description="Are you sure you want to delete this item? This item and all its combinations will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
} 